import { staticUrl } from '../lib/config/static-assets';

/** 与 components/legacy-game-home.tsx 壳样式保持一致。 */
export const SHELL_STYLESHEET_PATHS = [
  '/legacy-game-wiki/styles.css?v=20260924-cdn-static-v1',
  '/legacy-game-wiki/community.css?v=20260924-cdn-static-v1',
  '/legacy-game-wiki/layout-widths.css?v=20260924-cdn-static-v1',
  '/legacy-game-wiki/home-polish.css?v=20260930-mobile-benefit-status-return-v48',
  '/legacy-game-wiki/catalog-premium.css?v=20260930-landscape-support-v14',
  '/legacy-game-wiki/ui-board-overrides.css?v=20260928-game-scrim-v28',
] as const;

function pathMarker(path: string) {
  return path.split('?')[0] || path;
}

function findExistingLink(marker: string): HTMLLinkElement | null {
  const tagged = document.head.querySelector<HTMLLinkElement>(
    `link[data-spa-shell="${marker}"]`,
  );
  if (tagged) return tagged;
  return (
    Array.from(
      document.head.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'),
    ).find((el) => (el.getAttribute('href') || '').includes(marker)) || null
  );
}

function whenStylesheetReady(link: HTMLLinkElement): Promise<void> {
  return new Promise((resolve) => {
    let settled = false;
    const done = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    if (link.sheet) {
      done();
      return;
    }
    link.addEventListener('load', done, { once: true });
    link.addEventListener('error', done, { once: true });
    // 缓存命中时部分浏览器不会再触发 load
    requestAnimationFrame(() => {
      if (link.sheet) done();
    });
    window.setTimeout(done, 2500);
  });
}

let stylesPromise: Promise<void> | null = null;

/**
 * 尽早注入壳 CSS，并在全部就绪后 resolve。
 * 避免壳 markup 先上屏、样式后到造成 FOUC。
 */
export function prefetchShellStylesheets(): Promise<void> {
  if (typeof document === 'undefined') return Promise.resolve();
  if (stylesPromise) return stylesPromise;

  stylesPromise = Promise.all(
    SHELL_STYLESHEET_PATHS.map((path) => {
      const marker = pathMarker(path);
      const href = staticUrl(path);
      let link = findExistingLink(marker);
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.dataset.spaShell = marker;
        document.head.appendChild(link);
      } else {
        link.dataset.spaShell = marker;
      }
      return whenStylesheetReady(link);
    }),
  ).then(() => undefined);

  return stylesPromise;
}
